import { lazy } from 'react';
import { ChatComponent } from './types/chat.types';

// Shouldn't be lazy loaded since in it suspending other lazy imports 
import ContextProvider from './components/context-provider/ContextProvider';

const Messages = lazy(() => import('./components/messages/Messages')) as ChatComponent['Messages'];
const Input = lazy(() => import('./components/input/Input'));
const ActionModals = lazy(() => import('./components/action-modals/ActionModals')) as ChatComponent['ActionModals'];


const Chat: ChatComponent = () => {};
Chat.ContextProvider = ContextProvider;

Chat.Input = Input;
Chat.Messages = Messages;
Chat.ActionModals = ActionModals;
// Chat.Header = Header;
// Chat.Welcome = Welcome;
// Chat.Starters = Starters;

export { Chat };